// app/javascript/controllers/flash_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (!this.element.classList.contains('persistent') && !this.element.classList.contains('alert-danger')) {
      setTimeout(() => {
        this.element.style.transition = 'opacity 3s ease';
        this.element.style.opacity = '0';

        setTimeout(() => {
          this.element.remove();
        }, 3000); // give it time to fade

      }, 3000);
    }
  }
}